import ImageNew0 from './img/newin1.jpg';
import ImageNew1 from './img/newin2.jpg';
import ImageNew2 from './img/newin3.jpg';


export const dataNew = [
    {
        id: 1,
        images: ImageNew0,
        name: 'Innovative Serum',
        showMore: false,
        description: 
        'Natural serum for all skin types. With a camomile extract, natural retinol and collagen for a best results. Can be used for dry, normal and aging skin',
    },

    {
        id: 2,
        images: ImageNew1,
        name: 'Peeling & Tonic',
        showMore: false,
        description: 
        'Duo combo of peeling and tonic to get a splendid results. With rosemary extract to sooth and refresh skin! Used for any skin types, do not use with retinols.',
    },

    {
        id: 3,
        images: ImageNew2,
        name: 'Rose Water',
        showMore: false,
        description: 
        'For a fresh and natural moisture. Comes from a locally sourced roses and thermal water. Perfect for any skin types, provides ligth hydration.',
    },

]